//Login
export const LOGIN_STARTED = 'LOGIN_STARTED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

//KeyCloak
export const KEYCLOAK_INITIALIZATION = 'KEYCLOAK_INITIALIZATION';

//UserList
export const FETCH_USER_LIST_STARTED = 'FETCH_USER_LIST_STARTED';
export const FETCH_USER_LIST_SUCCESS = 'FETCH_USER_LIST_SUCCESS';
export const FETCH_USER_LIST_FAILURE = 'FETCH_USER_LIST_FAILURE';

//UserProfileData
export const USER_PROFILE_DATA_STARTED = 'USER_PROFILE_DATA_STARTED';
export const USER_PROFILE_DATA_SUCCESS = 'USER_PROFILE_DATA_SUCCESS';
export const USER_PROFILE_DATA_FAILURE = 'USER_PROFILE_DATA_FAILURE';
export const USER_PROFILE_AVATAR = 'USER_PROFILE_AVATAR';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js